<script  lang="ts">
import EntityInitSection from './EntityInitSection.vue'

export default {
    name: 'EntityHistorique',
    extends: EntityInitSection,
    computed: {
        hasBeenModified(): boolean {
            return this.data?.credentials.created_at !== this.data?.credentials.updated_at
        },
    },
}
</script>

<template>
    <FormSection v-if="data" title="Historique" with-borders-color="primary">
        <FormDatetime
            :enable-time-picker="true"
            data-key="credentials.created_at"
            :data
            :translation-name
        />
        <template v-if="data?.credentials?.created_by">
            <FormInput
                data-key="credentials.created_by.name"
                :data
                :translation-name
            />
        </template>
        <template v-if="hasBeenModified">
            <FormDatetime
                :enable-time-picker="true"
                data-key="credentials.updated_at"
                :data
                :translation-name
            />
            <template v-if="data?.credentials?.updated_by">
                <FormInput
                    data-key="credentials.updated_by.name"
                    :data
                    :translation-name
                />
            </template>
        </template>
    </FormSection>
</template>
